module.exports = __webpack_public_path__ + "img/klaas.50e4a825.png";